export const DATE_FORMAT = 'EE, d MMM';
